import React from 'react';

import { curYear, getYearArray } from '@zr/utilities/date';

export function YearOptions() {
  return (
    <>
      {getYearArray(1930, curYear)
        .reverse()
        .map((year) => <option key={year} value={year}>{year}</option>)}
    </>
  );
}

export default YearOptions;
